module.exports = __webpack_public_path__ + "static/media/avatar.db7ddd5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/sdks/agora/assets/avatar.png
// module id = 1339
// module chunks = 0